import { render, staticRenderFns } from "./FuelCharacteristics.vue?vue&type=template&id=b03313fa&scoped=true"
import script from "./FuelCharacteristics.vue?vue&type=script&lang=js"
export * from "./FuelCharacteristics.vue?vue&type=script&lang=js"
import style0 from "./FuelCharacteristics.vue?vue&type=style&index=0&id=b03313fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_eb30a0289a409b0a489ae932e3a15a73/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03313fa",
  null
  
)

export default component.exports